import { useMemo } from "react";
import { useTranslation } from "react-i18next";

export const useStepUpFlowTranslations = () => {
  const { t } = useTranslation();

  return useMemo(
    () => ({
      redirectTitle: t(
        "subIBReport_stepUpRedirectTitle",
        "We're redirecting you to verify this action",
      ),
      redirectBody: t(
        "subIBReport_stepUpRedirectBody",
        "Not redirected automatically? Try again or contact support@pepperstonepartners.com",
      ),
      verifyingArchiveTitle: t(
        "subIBReport_stepUpVerifyingArchiveTitle",
        "Closing your program...",
      ),
      verifyingCreateTitle: t(
        "subIBReport_stepUpVerifyingCreateTitle",
        "Creating your program...",
      ),
      verifyingBody: t(
        "subIBReport_stepUpVerifyingBody",
        "Stuck? Contact support@pepperstonepartners.com",
      ),
      errorTitle: t("subIBReport_stepUpErrorTitle", "Something is wrong"),
      errorBody: t(
        "subIBReport_stepUpErrorBody",
        "Try again or contact support@pepperstonepartners.com for help",
      ),
      retry: t("subIBReport_stepUpRetry", "Retry"),
      back: t("common_back", "Back"),
      close: t("common_close", "Close"),
    }),
    [t],
  );
};

export type StepUpFlowTranslations = ReturnType<
  typeof useStepUpFlowTranslations
>;
